import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullTeamV4 from "@irati/identity/services/fragments/fullTeamV4"

const query = gql`
  query billingUnits($businessId: ID!) {
    billingUnits(businessId: $businessId) {
      regionId
      region
      teamId
      team {
        ...fullTeam
      }
    }
  }
  ${fullTeamV4}
`

export const billingUnitsKey = getQueryNames(query)[0]

export default query
